<div class="content">
  <div class="content-panel">
    <div translate="">page.auth.disabled</div>
  </div>
</div>
